<script>
	import Basket from '../Stores/Basket';
	import Layout from '../Stores/Layout';
	import Menu from '../Stores/Menu';
	import Product from '../Stores/Product';

	let products = [];

	function load(product) {
		Layout.info();
		Product.load(product.id);
		$Menu.open = false;
	}

	function setProducts() {
		let list = [];
		if ($Product.products)
			for (let product of $Product.products)
				if (!$Basket.restored || (product.id === $Product.id))
					list.push(product);

		products = list;
	}

	Product.subscribe(data => setProducts());
	Basket.subscribe(data => setProducts());
</script>

<style>
	div.zes-products {
		text-align: center;
		padding-top: 1.75em;
		width: 23%;
		background-color: hsl(0deg 0% 98%);
	}

	div.zes-products > div {
		padding: 1.25em .75em;
		border-bottom: 1px solid hsl(0deg 0% 90%);
		cursor: pointer;
	}

	div.zes-products > div:hover {
		background: hsl(0deg 0% 0% / .05);
	}

	div.zes-products > div.zes-active {
		background: var(--zes-1-4) !important;
	}

	div.zes-products > div span {
		font-size: .7em;
		font-weight: 600;
		color: var(--zes-1-3);
		margin-bottom: .1em;
		display: block;
	}

	div.zes-products > div div {
		font-size: 1em;
		font-weight: 700;
		color: var(--zes-1-2);
		margin-bottom: .1em;
	}

	div.zes-products > div em {
		font-size: .7em;
		font-style: normal;
		color: var(--zes-3-1);
		display: block;
	}

	div.zes-products > div.zes-active * {
		color: var(--zes-1-2);
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-products {
			padding-top: .5em;
		}
	}
</style>

<div class="zes-products zes-scroll">
	{#each products as product}
		<div on:click="{load(product)}" class:zes-active="{product.id === $Product.id}">
			<span>{product.make}</span>
			<div>{product.name}</div>
			<em>vanaf <b>{Product.price(product.price)}</b></em>
		</div>
	{/each}
</div>